import { FETCH_EXAM_CODES_ERROR, FETCH_EXAM_CODES_START, FETCH_EXAM_CODES_SUCCESS } from "../../actions/receptionist/examCodesAction";

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    examCodes: []
};

const examCodesReducer = (state = INIT_STATE, action) => {
    let newState;
    let newVisits;
    let index;
    switch (action.type) {
        case FETCH_EXAM_CODES_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_EXAM_CODES_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, examCodes: [...action.examCodes] };

        }
        case FETCH_EXAM_CODES_ERROR: {
            return { ...state, error: action.error, message: '', loading: false };
        }

        default:
            return state;
    }
}

export default examCodesReducer;